import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Box from '@material-ui/core/Box';
import TagDataView from './TagDataView';
import VariableDataView  from './VariableDataView';
import TriggerDataView  from './TriggerDataView';

import DonutChart from './chart/DonutChart';
import Paper from '@material-ui/core/Paper';
import { useOvermind } from '../../overmind';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function DataTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { state } = useOvermind();
  const tabLabel = ['Tag View','Variable View','Trigger View']

  const handleChange = (event, newValue) => {
    window.dataLayer.push({'event':'docTabChange','Label':tabLabel[newValue]})
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Tag View" {...a11yProps(0)} />
          <Tab label="Variable View" {...a11yProps(1)} />
          <Tab label="Trigger View" {...a11yProps(2)} />

        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Paper>
          <DonutChart type="Tag" data={state.docDonutChart.tags} />
        </Paper>
        <TagDataView/>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <Paper>
          <DonutChart type="Variable" data={state.docDonutChart.variables} />
        </Paper>
        <VariableDataView />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Paper>
          <DonutChart type="Trigger" data={state.docDonutChart.triggers} />
        </Paper>
        <TriggerDataView/>
      </TabPanel>

    </div>
  );
}
